import React from "react"
import LoanAccountingForm from './Form'

export default function CreateLoanAccounting() {
  return <LoanAccountingForm isUpdate={ true } />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanAccounting/Create.js